import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Image as ImageIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

const tourPackages = [
  {
    title: "Udaipur City Tour",
    subtitle: "Lakes • Palaces • Heritage",
    image: "/images/udaipur3.jpg",
    slug: "udaipur-tour",
    price: "From ₹2,500",
  },
  {
    title: "Mount Abu Tour",
    subtitle: "Hill Station Getaway",
    image: "/images/mountabu.jpg",
    slug: "mount-abu-tour",
    price: "From ₹4,500",
  },
  {
    title: "Jaisalmer Sightseeing",
    subtitle: "Golden Fort • Desert • Culture",
    image: "/images/jaisalmer2.jpg",
    slug: "jaisalmer-sightseeing",
    price: "From ₹6,500",
  },
  {
    title: "Nakoda Ji Darshan",
    subtitle: "Jain Tirth • Pilgrimage Tour",
    image: "/images/nakodaji1.jpg",
    slug: "nakoda-ji-darshan",
    price: "From ₹5,500",
  },
];

const TourPackagesSection = () => {
  const WHATSAPP_NUMBER = "919928012345";
  const navigate = useNavigate();
  const handleEnquiry = (tourTitle) => {
    const message = encodeURIComponent(
      `Hello Bahubali Cabs! I'm interested in the "${tourTitle}" tour package. Please share complete details.`,
    );
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, "_blank");
  };

  return (
    <section className="bg-slate-50 py-24">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight">
            Popular Tour Packages
          </h2>
          <p className="text-slate-500 mt-4 font-medium italic">
            Discover Rajasthan with Bahubali Cabs
          </p>
        </div>

        {/* Tour Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {tourPackages.map((tour, index) => (
            <motion.div
              key={tour.slug}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group rounded-[2rem] overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 bg-white"
            >
              {/* Image */}
              <div className="h-64 relative overflow-hidden bg-slate-200 flex items-center justify-center">
                <img
                  src={tour.image}
                  alt={tour.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.nextSibling.style.display = "flex";
                  }}
                />

                {/* Fallback */}
                <div className="hidden flex-col items-center text-slate-400">
                  <ImageIcon className="w-10 h-10 mb-2" />
                  <span className="text-xs font-bold uppercase tracking-widest">
                    Image Coming Soon
                  </span>
                </div>

                {/* Price Badge */}
                <div className="absolute top-4 right-4 z-10">
                  <span className="bg-amber-500 text-slate-900 px-4 py-1.5 rounded-full text-xs font-black shadow-lg">
                    {tour.price}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 space-y-4">
                <div>
                  <span className="text-amber-600 text-xs font-bold uppercase tracking-wider block mb-1">
                    {tour.subtitle}
                  </span>
                  <h3 className="text-slate-900 font-black text-xl tracking-tight leading-snug">
                    {tour.title}
                  </h3>
                </div>

                <div className="flex gap-3 pt-2">
                  <button
                    onClick={() => navigate(`/tours/${tour.slug}`)}
                    className="flex-1 bg-slate-900 text-white font-bold py-3.5 rounded-xl hover:bg-slate-800 transition text-sm"
                  >
                    View Details
                  </button>

                  <button
                    onClick={() => handleEnquiry(tour.title)}
                    className="flex-1 bg-amber-500 text-slate-900 font-bold py-3.5 rounded-xl hover:bg-amber-400 transition text-sm"
                  >
                    WhatsApp
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TourPackagesSection;
